import { inject, Injectable } from '@angular/core';
import { App, AppState } from '@capacitor/app';
import { Socket } from 'ngx-socket-io';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class AppStateService {
  private socket = inject(Socket);

  appState$ = new Subject<boolean>();

  constructor() {
    App.addListener('appStateChange', (state: AppState) => {
      const appStateStatusIsActivate = state.isActive;

      if (appStateStatusIsActivate) {
        if (!this.socket.ioSocket.connected) {
          this.socket.connect();
        }
      }

      this.appState$.next(appStateStatusIsActivate);

    });
  }

}
